<template>
  <div v-if="body != null" class="page">
    <section class="text_center">
      <h2 class="header_underline">{{ title }}</h2>
      <div v-html="body" class="page_body text_left"></div>
    </section>
  </div>
  <div v-else-if="isNotFound">
    <NotFound />
  </div>
</template>

<script>
import { GET_PAGE_ADDED } from '@/store/page/actions'
import NotFound from '@/components/404.vue'

export default {
  name: 'PageView',
  components: {
    NotFound
  },
  data () {
    return {
      code: this.$route.params.code || '',
      title: '',
      body: null,
      isNotFound: false
    }
  },
  computed: {
    paramsCode () {
      return this.$route.params.code || ''
    }
  },
  methods: {
    getPageAdded () {
      this.$store.dispatch(GET_PAGE_ADDED, {
        code: this.code
      })
        .then((data) => {
          this.title = data.title
          this.body = data.body
        })
        .catch((error) => {
          if (error.errorStatus === 404) {
            this.isNotFound = true
          }
        })
    }
  },
  created () {
    this.getPageAdded()
  },
  watch: {
    paramsCode (val, old) {
      this.code = val
      this.title = ''
      this.body = null
      this.isNotFound = false
      this.getPageAdded()
    }
  }
}
</script>
